import confettiGif from './confetti.gif'

export const Confetti = ({
  ...props
}: {
  [key: string]: string | number
}): JSX.Element => {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  return <img src={confettiGif} {...props} alt="ta-da" />
}
